import PropTypes from 'prop-types';

export default PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.string),
  PropTypes.object,
  PropTypes.string
]);
